import {
	TOGGLE_NOTICE_WRITE,
	TOGGLE_NOTICE_POPUP,
} from "./actionTypes";

export const toggleNotice = isOpen => ({
	type: TOGGLE_NOTICE_WRITE,
	payload: isOpen
});

export const toggleNoticePopup = isOpen => ({
	type: TOGGLE_NOTICE_POPUP,
	payload: isOpen
});